import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "../api";
import { FeatureCollection, Geometry } from "geojson";
import { SceneFeature } from "../types/scenes";

function useDeleteScene(sceneId?: string) {
  const queryClient = useQueryClient();
  const { isPending, isSuccess, error, mutate } = useMutation({
    mutationFn: () => {
      if (!sceneId) throw new Error("No scene Id provided to delete scene");
      return API.deleteScene(sceneId);
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["scenes", sceneId], exact: true });
      queryClient.setQueriesData(
        { queryKey: ["scenes"]},
        (scenes: FeatureCollection<Geometry, SceneFeature> | undefined ) => {
          if (!scenes || !scenes.features) return scenes;
          return {
            ...scenes,
            features: scenes.features.filter(({ properties }) => properties.s3_prefix !== sceneId)
          };
        }
      );
    }
  });

  return {
    deleteScene: () => mutate(),
    isPending,
    isSuccess,
    error
  };
}

export default useDeleteScene;
